import { render, staticRenderFns } from "./OnOffSwitch.vue?vue&type=template&id=a3ad4f3e"
import script from "./OnOffSwitch.vue?vue&type=script&lang=js"
export * from "./OnOffSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports